module.exports = __webpack_public_path__ + "static/img/logo.fad8c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 604
// module chunks = 1